(() => {
  if (window.NiPAPdpGalleryPickerLoaded) return;
  window.NiPAPdpGalleryPickerLoaded = true;

  const optionRoot = () => document.querySelector('.main-product--root product-options-element[data-id]');

  const optionGroup = (index) => {
    const root = optionRoot();
    return root ? root.querySelector('.product-options--option[data-index="' + CSS.escape(String(index)) + '"]') : null;
  };

  const currentValue = (index) => {
    const group = optionGroup(index);
    if (!group) return '';
    const disclosure = group.querySelector('.disclosure--input');
    if (disclosure) return disclosure.value;
    const checked = group.querySelector('input:checked');
    return checked ? checked.value : '';
  };

  const refreshPressedState = () => {
    document.querySelectorAll('[data-nipa-media-choose]').forEach((button) => {
      const selected = currentValue(button.dataset.optionIndex) === button.dataset.optionValue;
      const icon = button.querySelector('[data-nipa-choice-icon]');
      const label = button.querySelector('[data-nipa-choice-label]');
      const isEnglish = document.documentElement.lang.toLowerCase().startsWith('en');
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      button.disabled = selected;
      button.setAttribute(
        'aria-label',
        selected
          ? (isEnglish ? 'Color ' + button.dataset.optionValue + ' selected' : 'Color ' + button.dataset.optionValue + ' seleccionado')
          : (isEnglish ? 'Choose color ' + button.dataset.optionValue : 'Elegir color ' + button.dataset.optionValue)
      );
      if (icon) icon.textContent = selected ? '✓' : '+';
      if (label) label.textContent = selected ? (isEnglish ? 'Selected' : 'Elegido') : (isEnglish ? 'Choose' : 'Elegir');
    });
  };

  const selectOptionValue = (index, value) => {
    const group = optionGroup(index);
    if (!group) return false;

    const disclosureOption = Array.from(group.querySelectorAll('.disclosure--option'))
      .find((option) => option.dataset.value === value);
    if (disclosureOption) {
      disclosureOption.click();
      return true;
    }

    const radio = Array.from(group.querySelectorAll('input[type="radio"]'))
      .find((input) => input.value === value);
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    return false;
  };

  const productVariants = () => {
    const root = optionRoot();
    const script = root && root.querySelector('[data-nipa-product-variants]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return [];
    }
  };

  const chooseOption = async (button) => {
    const targetIndex = Number(button.dataset.optionIndex);
    const targetValue = button.dataset.optionValue;
    const root = optionRoot();
    if (!root || !optionGroup(targetIndex)) return false;

    const groups = Array.from(root.querySelectorAll('.product-options--option'));
    const currentValues = groups.map((group, index) => currentValue(index));
    currentValues[targetIndex] = targetValue;

    const variants = productVariants();
    let chosenVariant = variants.find((variant) =>
      variant.available && variant.options.every((value, index) => value === currentValues[index])
    );

    if (!chosenVariant) {
      chosenVariant = variants.find((variant) =>
        variant.available && variant.options[targetIndex] === targetValue
      );
    }

    const desiredValues = chosenVariant ? chosenVariant.options : currentValues;
    const requiresAvailableFallback = chosenVariant && chosenVariant.options.some(
      (value, index) => index !== targetIndex && value !== currentValue(index)
    );

    if (requiresAvailableFallback) {
      const productUrl = root.dataset.productUrl || window.location.pathname;
      window.location.assign(productUrl + '?variant=' + chosenVariant.id);
      return true;
    }

    let changed = false;

    const updateOrder = [
      targetIndex,
      ...desiredValues.map((value, index) => index).filter((index) => index !== targetIndex)
    ];

    for (const index of updateOrder) {
      if (currentValue(index) === desiredValues[index]) continue;
      changed = selectOptionValue(index, desiredValues[index]) || changed;
      const settleDelay = index === targetIndex ? 650 : 220;
      await new Promise((resolve) => window.setTimeout(resolve, settleDelay));
    }

    return changed;
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-nipa-media-choose]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    if (!(await chooseOption(button))) return;
    window.requestAnimationFrame(refreshPressedState);
    window.setTimeout(() => {
      refreshPressedState();
      button.focus({ preventScroll: true });
    }, 180);
  }, true);

  document.addEventListener('change', (event) => {
    if (event.target.closest('product-options-element')) {
      window.requestAnimationFrame(refreshPressedState);
    }
  });

  document.addEventListener('click', (event) => {
    const option = event.target.closest('.disclosure--option');
    if (!option) return;
    const disclosure = option.closest('disclosure-element');
    const toggle = disclosure && disclosure.querySelector('.disclosure--toggle');
    if (toggle) window.setTimeout(() => toggle.focus({ preventScroll: true }), 0);
  });

  document.addEventListener('keydown', (event) => {
    const option = event.target.closest('.disclosure--option');
    if (!option || (event.key !== ' ' && event.key !== 'Spacebar')) return;
    event.preventDefault();
    option.click();
  });


  let lastModalTrigger = null;
  let lastModalScrollY = 0;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.product-media--modal, .product-size-chart--link');
    if (!trigger) return;

    lastModalTrigger = trigger;
    lastModalScrollY = window.scrollY;

    if (trigger.matches('.product-size-chart--link')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (typeof window.trigger === 'function') {
        window.trigger('theme:modal:open:' + trigger.dataset.id, { index: 0 });
      }
    }
  }, true);

  document.addEventListener('keydown', (event) => {
    const trigger = event.target.closest('.product-media--modal, .product-size-chart--link');
    if (!trigger || (event.key !== ' ' && event.key !== 'Spacebar')) return;
    event.preventDefault();
    trigger.click();
  });

  const restoreModalFocus = () => {
    if (!lastModalTrigger || !document.contains(lastModalTrigger)) return;
    window.setTimeout(() => {
      const openModal = Array.from(document.querySelectorAll('modal-element'))
        .some((modal) => modal.getAttribute('aria-hidden') === 'false');
      if (!openModal) {
        window.scrollTo({ top: lastModalScrollY, left: 0, behavior: 'auto' });
        lastModalTrigger.focus({ preventScroll: true });
        lastModalTrigger = null;
      }
    }, 900);
  };

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') restoreModalFocus();
  }, true);

  document.addEventListener('click', (event) => {
    if (event.target.closest('modal-element button, .modal--close')) restoreModalFocus();
  });

  const start = () => {
    refreshPressedState();
    window.setTimeout(refreshPressedState, 300);
  };

  window.addEventListener('pageshow', start);
  document.addEventListener('shopify:section:load', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();